import { combineReducers } from "redux"

// Front
import HorizontalLayout from "./horizontalLayout/HorizontalLayout.js"

// Authentication
import detailSet from "./auth/detail/detailSet.js"
import ForgetPassword from "./auth/forgetpwd/forgetPassword.js"
import Login from "./auth/login/login.js"
import pwdSet from "./auth/newPassword/pwdSet.js"
import Profile from "./auth/profile/profile.js"
import updatePasswordReducer from "./auth/profile/updatepassword/updatePasswordReducer.js"
import account from "./auth/register/account.js"
import resetPassword from "./auth/resetPassword/resetPassword.js"
import verifymail from "./auth/verificationMail/verifymail.js"

//Candidate List
import getCandidateList from "./auth/organization/candidates/list/getCandidateList.js"
//matching
import matchingReducer from "./process/matching/matchingReducer"
//Candidates Count
import getCandidateCount from "./auth/organization/candidates/count/getCandidateCount.js"
//Parsing Resume
import getParsingResume from "./auth/resumeParsing/getParsingResume.js"


//bulkimport
import bulkimportreducer from "./auth/bulkimport/bulkimportreducer.js"
// view candidate 
import viewCandidateReducer from "./auth/organization/candidates/viewCandidate/viewCandidateReducer.js"


//Dashboard
import getPublishedJobsReducer from "./auth/organization/Dashboard/PublishedJobs/getPublishedJobsReducer.js"

//AImarkup
import getAImarkupReducer from "./auth/organization/AiModal/getAImarkupReducer.js"


//myteam
import addUserReducer from "./auth/myteam/adduser/addUserReducer.js"
import getUsersReducer from "./auth/myteam/getUsersReducer.js"
import getUpdateUserReducer from "./auth/myteam/updateuser/getUpdateUserReducer.js"

//Job List
import getJobList from "./auth/organization/jobs/list/getJobList.js"
//Job Count
import getJobCount from "./auth/organization/jobs/count/getJobCount.js"
//Parsing Job
import getParsingJd from "./auth/jdParsing/getParsingJd.js"
// view job
import viewJobReducer from './auth/organization/Job/viewJob/viewJobReducer.js'
//recruiter reducer
import RecruiterOrganizationReducer from "./auth/Recruiter/Organization/RecruiterOrganizationReducer.js"
import RecuriterDetailSet from "./auth/Recruiter/Profile/RecuriterDetailSet.js"
//feedback
import submitFeedBackReducer from "./auth/feedback/submitFeedBackReducer.js"

//candidate interview
import CandidateInterviewReducer from "./auth/feedback/CandidateInterviewFeedback/CandidateInterviewReducer.js"


import CandidateInterestReducer from "./auth/feedback/CandidateInterest/CandidateInterestReducer.js"
// career info 
import careerInfoReducer from "./auth/Career/careerInfoReducer.js"

// interview Scheduler reducer
import scheduleInterviewReducer from "./auth/organization/candidates/ScheduleInterview/scheduleInterviewReducer.js"

  
  
import candidateInterviewDetailsReducer from "./auth/organization/candidates/CandidateInterviewDetails/candidateInterviewDetailsReducer.js"

import getInterviewReducer from "./auth/Interview/getInterviewReducer.js"

import getNotificationReducer from "./auth/organization/notification/getNotificationReducer.js"

import getTemplateConfiguration from "./auth/organization/TemplateConfiguration/getTemplateConfiguration.js"

import openJobsReducer from "./auth/organization/candidates/openjobs/openJobsReducer.js"
import myCompanyReducer from "./auth/myCompany/myCompanyReducer.js"

import ManageAssessmentReducer from "./auth/Recruiter/ManageAssessment/ManageAssessmentReducer.js"
import assesmentQuesionsReducer from "./auth/organization/AssesmentQuestions/assesmentQuesionsReducer.js"
import oauthCallbackReducer from "./auth/organization/oauthCallback/oauthCallbackReducer.js"

import documentsReducer from "./process/documents/documentsReducer.js"

//submit document
import submitDocumentReducer from "./auth/feedback/submitDocument/submitDocumentReducer.js"

import questionsReducer from "./auth/Questions/questionsReducer.js"

import assesmentTestReducer from "./auth/feedback/AssessmentTest/assesmentTestReducer.js"
import nonAuthenticatepagesReducer from "./nonAuthenticatePages/nonAuthenticatepagesReducer.js"

import migrationReducer from "./auth/Migration/migrationReducer.js"

import thirdPartyAppReducer from "./auth/Config/ThirdPartApp/thirdPartyAppReducer.js"

import DomainConfiguration from "./auth/organization/DomainManagement/DomainConfiguration.js"

import showLoaderReducer from "./auth/LoaderAndMessageStore/showLoaderReducer.js"
import managersReducer from "./auth/organization/Managers/managersReducer.js"

import Layout from './layout/Layout.js'

//hire decision
import hireDecisionReducer from "./auth/organization/HireDecision/hireDecisionReducer.js"

//offer letter list
import OfferLetterListReducer from "./auth/organization/offerLetters/OfferLetterListReducer.js"
//verification documents lsiting page
import verificationDocReducer from "./auth/organization/DocumentVerificationDetails/verificationDocReducer.js"

//email template
import emailGetTemplateConfiguration from "./auth/organization/EmailTemplate/emailGetTemplateConfiguration.js"

//CAREER POP CONFIG
import getCareerPopUpReducer from "./auth/organization/CareerPopUp/getCareerPopUpReducer.js"

import zohoIntegrationReducer from "./auth/zohoIntegration/zohoIntegrationReducer.js"

//prescreening reducer
import PrescreeningQuestionsReducer from "./auth/PrescreeningQuestions/PrescreeningQuestionsReducer.js"

import emailIntegrationReducer from "./auth/emailIntegration/emailIntegrationReducer.js"
///recruitment process reducer
import impersonateReducer from "./auth/Impersonate/impersonateReducer.js"
import reportReducer from "./auth/Reports/reportReducer.js"
import videoResumeReducer from "./auth/candidate/videoResume/videoResumeReducer.js"
import reportIssueReducer from "./auth/issues/reportIssueReducer.js"
import linkedinReducer from "./auth/jobDistributation/Linkedin/linkedinReducer.js"
import assessmentDetailsReducer from "./process/Hiring-Process/Assessment/assessmentDetailsReducer.js"
import screenDetailsReducer from "./process/Hiring-Process/Screen/screenDetailsReducer.js"
import shortlistDetailsReducer from "./process/Hiring-Process/Shortlist/shortlistDetailsReducer.js"
import ProcessAssessmentDetailsReducer from "./process/assessments/ProcessAssessmentDetailsReducer.js"
import HireReducer from "./process/hire/HireReducer.js"
import InterviewReducer from "./process/interview/InterviewReducer.js"
import mappingReducer from "./process/mapping/mappingReducer.js"
import OfferReducer from "./process/offer/OfferReducer.js"
import screenReducer from "./process/screen/screenReducer.js"
import ShortlistReducer from "./process/shortlist/ShortlistReducer.js"
import timeLineReducer from "./process/timeline/timeLineReducer.js"
const rootReducer = combineReducers({
  // public
  matching: matchingReducer,
  Layout,
  HorizontalLayout,
  Login,
  account,
  ForgetPassword,
  Profile,
  pwdSet,
  verifymail,
  detailSet,
  resetPassword,
  getCandidateList,
  getCandidateCount,
  getParsingResume,
  bulkimportreducer,
  viewCandidateReducer,
  getPublishedJobsReducer,
  getAImarkupReducer,
  getUsersReducer,
  getUpdateUserReducer,
  addUserReducer,
  getJobList,
  getJobCount,
  getParsingJd,
  viewJobReducer,
  updatePasswordReducer,
  RecruiterOrganizationReducer,
  RecuriterDetailSet,
  submitFeedBackReducer,
  CandidateInterviewReducer,
  CandidateInterestReducer,
  scheduleInterviewReducer,
  candidateInterviewDetailsReducer,
  getInterviewReducer,
  getNotificationReducer,
  getTemplateConfiguration,
  openJobsReducer,
  myCompanyReducer,
  oauthCallbackReducer,
  assesmentQuesionsReducer,
  ManageAssessmentReducer,
  documentsReducer,
  submitDocumentReducer,
  questionsReducer,
  assesmentTestReducer,
  nonAuthenticatepagesReducer,
  migrationReducer,
  thirdPartyAppReducer,
  DomainConfiguration,
  showLoaderReducer,
  managersReducer,
  careerInfoReducer,
  hireDecisionReducer,
  OfferLetterListReducer,
  verificationDocReducer,
  emailGetTemplateConfiguration,
  getCareerPopUpReducer,
  zohoIntegrationReducer,
  PrescreeningQuestionsReducer,
  emailIntegrationReducer,
  screenReducer,
  mappingReducer,
  ShortlistReducer,
  InterviewReducer,
  HireReducer,
  OfferReducer,
  ProcessAssessmentDetailsReducer,
  reportReducer,
  timeLineReducer,
  videoResumeReducer,
  screenDetailsReducer,
  shortlistDetailsReducer,
  assessmentDetailsReducer,
  linkedinReducer,
  impersonateReducer,reportIssueReducer
})

export default rootReducer

